/**
 * Labels d'affichage des modules métier.
 *
 * ⚠️ IMPORTANT — Ce fichier est UNIQUEMENT pour l'affichage utilisateur.
 * Les champs backend, clés d'onglets et data-testid conservent les noms
 * techniques historiques (`easy_power_stage`, `chantier_stage`, `activeTab === 'easy_power'`,
 * etc.) pour éviter toute migration DB / régression fonctionnelle.
 *
 * Pour changer un libellé un jour → 1 seul endroit à modifier.
 */

import { Handshake, Wrench } from 'lucide-react';

export const MODULE_LABELS = {
    easy_power: 'Courtage',
    easy_power_short: 'Courtage',
    easy_power_lost: 'Courtage — Affaire perdue',
    easy_power_owner: 'Courtage',
    chantier: "Travaux d’optimisation",
    chantier_short: 'Travaux',
    chantier_lost: "Travaux d’optimisation — Affaire perdue",
    chantier_owner: "Travaux d’optimisation",
};

/**
 * Icônes officielles des modules métier (Lucide). Utilise-les partout
 * pour l'homogénéité visuelle : plus jamais `<Zap>` pour Courtage ni
 * `<HardHat>` pour Travaux.
 */
export const MODULE_ICONS = {
    easy_power: Handshake,
    chantier: Wrench,
};

export const MODULE_COLORS = {
    easy_power: {
        text: 'text-amber-700',
        bg: 'bg-amber-100',
        border: 'border-amber-200',
        icon: 'text-amber-600',
        accent: 'text-amber-600',
    },
    chantier: {
        text: 'text-blue-700',
        bg: 'bg-blue-100',
        border: 'border-blue-200',
        icon: 'text-blue-600',
        accent: 'text-blue-600',
    },
};

/** Retourne le label lisible d'un module technique. */
export function moduleLabel(moduleKey) {
    return MODULE_LABELS[moduleKey] || moduleKey;
}
